import {BehaviorSubject} from 'rxjs';
import auth from '../services/authentication';
import testQueriesNew from '../../content/testQueriesNew';
import testQueries from '../../content/testQueries';
import testQueriesUpdated from '../../content/testQueriesUpdated';
import wsClient from '../ws/client';
import Api from '../api/Api';
import {floor, isFunction} from 'lodash';

interface IResultSet{
  query: string,
  rank?: number,
  page?: number,
}
interface IDatasetMapProps{
  [key:string]: Array<any>,
}
interface IPlatformKeyProps{
  [key:string]: string|Function,
}
interface modelProps{
  queryNoAI: string,
  query: string,
  type: string,
  platform: string,
  accounts: string,
  resId: string,
}
interface modelMappingProps {
  [key:string]: modelProps
}
interface dataModelsProps {
  [key:string]: Function,
}
interface ITransformValue {
  [key:string]: Function,
}
const platformResKey:IPlatformKeyProps = {
  gmail: 'internetMessageId',
  slack: (item:any) => item.permalink?.split('?')[0],
  dropbox: 'url',
  jira: (item:any) => {
    let teamLink = item.result_id.split('-')[1];
    teamLink = `${teamLink}/browse/${item.key}`;
    return teamLink;
  },
  'office-365': (item:any) => {
    if (item['o365-platform'] !== 'teams') {
      return item.id;
    }
    return `${item.channel_id}-${item.msg_id}`;
  },
  teams: (item: any) => {
    return `${item.channel_id}-${item.msg_id}`;
  },
  gdrive: (item:any) => {
    const link = item.webViewLink?.split('/');
    if (link) {
      link.pop();
      return link.join('/');
    }
    return '';
  },
}
const datasetMapping:IDatasetMapProps = {
  old: testQueries,
  new: testQueriesNew,
  updated: testQueriesUpdated,
}
const dataModelMapping:modelMappingProps = {
  updated: {
    queryNoAI: 'Current-query',
    query: 'Query',
    type: 'Entity',
    platform: 'Platform',
    accounts: 'test-account',
    resId: 'Groundtruth'
  },
  new: {
    queryNoAI: 'Query',
    query: 'Query',
    type: 'Entity',
    platform: 'Platform',
    accounts: 'test-account',
    resId: 'Groundtruth'
  },
  old: {
    queryNoAI: 'Query',
    query: 'Query',
    type: 'Entity',
    platform: 'Platform',
    accounts: 'test-account',
    resId: 'Groundtruth'
  }
}
const transformValue:ITransformValue = {
  gdrive: (value:string) => {
    const link = value.split('/');
    link.pop();
    return link.join('/');
  },
  'office-365': (value:string) => btoa(unescape(encodeURIComponent(value))),
  teams: (value:string) => {
    const linkPart = value.split('?')[0];
    const parts = linkPart.split('/');
    const msgId = parts[parts.length - 1];
    const channelId = parts[parts.length - 2];
    return `${channelId}-${msgId}`;
  }
}
const dataModels:dataModelsProps = {
  updated: (item:any) => {
    const { queryNoAI, query, accounts, platform, resId, type } = dataModelMapping.updated;
    let platformKey = item[platform].toLowerCase();
    if (platformKey === 'o365') {
      platformKey = 'office-365';
    }
    let resultKey:any = platformResKey[platformKey];

    return {
      query: item[queryNoAI] || item[query],
      accounts: item[accounts].split(/,|;/gm),
      platforms: [{
        key: platformKey,
        name: item[platform],
        result: {
          key: resultKey,
          value: item[resId],
          types: item[type].split('/'),
        }
      }],
    }
  },
  new: (item: any) => {

  }
}
const token = auth.getToken();
const getSearchId = async (query:string) => {
  return new Promise((resolve, reject) => {
    let wsConnection:any = null;
    let searchId:string = '';
    const connection = wsClient({
      url: 'ws-search',
      queryParams: {
        query,
        token,
      },
      onConnect: () => {
        wsConnection = connection;
      },
      onDisconnect: async () => {
        // no connection made
        if (!wsConnection) {
          // if socket does not connect (like localhost:3000) fallback to old API
          // or disconnects without giving a searchId
          const resp = await Api.mqSearch(query);
          resolve(resp.data.search_id);
        } else {
          if (searchId) {
            resolve(searchId);
          } else {
            reject('no search id provided')
          }

        }
        wsConnection = null;
      },
      onMessage: (data:any) => {
        if (data.search_id) {
          searchId = data.search_id;
        }
      },
    });
  })

}

const normalize = (dataset:Array<any>, type: string) => {
  const data:Array<any> = [];

  dataset.forEach((item: any) => {
    const normalized = dataModels[type](item);
    if (!normalized.platforms[0].result?.value) {
      return;
    }
    if (!normalized.query && data.length) {
      data[data.length - 1].platforms.push(normalized.platforms[0]);
    } else {
      data.push(normalized);
    }
  });
  return data;
}

const GtcStore = {
  currentQueries$: new BehaviorSubject<Array<any>>(testQueriesUpdated),
  dataSetName$: new BehaviorSubject<string>('updated'),
  dataSet$: new BehaviorSubject<Array<any>>([]),
  results$: new BehaviorSubject<Array<IResultSet>>([]),
  loading$: new BehaviorSubject<Boolean>(false),
  setDataSet(set:string) {
    if (datasetMapping[set]) {
      this.dataSetName$.next(set);
      this.currentQueries$.next(datasetMapping[set]);
      this.getUserDataSet();
    }
  },
  getUserDataSet() {
    const userEmail = auth.getEmail();
    const currentQueries = this.currentQueries$.getValue();
    const res = currentQueries.filter(q => {
      if (q['test-account']) {
        return q['test-account'].indexOf(userEmail) > -1
      }
      if (q['Login-email']) {
        return q['Login-email'].indexOf(userEmail) > -1
      }
      return false;
    });
    this.dataSet$.next(res);
  },
  async startTest(pl?:string) {
    this.loading$.next(true);
    this.results$.next([]);
    let dataSet = this.dataSet$.getValue();
    if (pl) {
      dataSet = dataSet.filter(dq => dq['Platform'].toLowerCase() === pl);
    }
    const data = normalize(dataSet, this.dataSetName$.getValue());
    try {
      for (let d of data) {
        const searchId:any = await getSearchId(d.query);
        const searchData = await this.processSearch(searchId, d);
        const currentRes = this.results$.getValue();
        const newRes = [...currentRes, searchData];
        this.results$.next(newRes);
      }
    } catch (err) {
      console.error(err);
    }

    this.loading$.next(false);
  },
  async processSearch(searchId:string, item:any) {
    let page = 1;
    const res = {
      query: item.query,
      platforms: [...item.platforms],
      latency: {},
    }
    const fetchPage = async () => {
      const reqPerf = performance.now();
      const { data } = await Api.pageSearch(page, searchId, 'all', null);
      res.platforms
        .filter((pl) => !pl.result.rank)
        .forEach(pl => {
          const found:any = findItem(data, pl);
          if (found) {
            pl.result.rank = found.rank + 1;
          }
          pl.result.page = page;
        });
      //@ts-ignore
      res.latency[`${page}`] = floor(((performance.now() - reqPerf) % 60000) / 1000, 2);
      if (res.platforms.some(pl => !pl.result.rank) && !data?.last_page) {
        page += 1;
        await fetchPage();
      }
    }
    await fetchPage();

    return res;
  },
}

const findItem = (data:any, platform:any) => {
  if (!data) {
    return null;
  }
  const found = data.message?.find((msg:any) => {
    if (msg.platform !== platform.key) {
      if (msg.platform === 'office-365' && msg['o365-platform'] === 'teams') {
        //return false;
      } else {
        return false;
      }
    }
    if (isFunction(platform.result.key)) {
      const {value} = platform.result;
      let val = value;
      if (transformValue[platform.key]) {
        val = transformValue[platform.key](val);
      }
      return platform.result.key(msg) === val;
    }
    return msg[platform.result.key] === platform.result.value;
  });
  if (found) {
    return {
      rank: found.rank,
    }
  }
  return null;
}

export default GtcStore;